import escape from 'lodash/escape';

export function toSafeHtmlString(root: HTMLElement) {
	const clonedRoot = root.cloneNode(true) as HTMLElement;

	// The code below uses `escape` function to replace harmful characters with their HTML entities.
	// However `innerHTML` already escapes `&` characters, but not others like `<`, `>`, etc.
	// With that, to avoid double escaping, we need to replace `&` characters with a placeholder
	// before escaping the rest of the characters. And restore it back at the very end.
	const ampPlaceholder = '😊amp🙁';

	function sanitize(node: Node) {
		if (!node) {
			return;
		}

		if (node.nodeType === 1 /* Node.ELEMENT_NODE */) {
			const element = node as HTMLElement;
			for (let i = 0; i < element.attributes.length; i++) {
				const attr = element.attributes[i];
				attr.value = escape(attr.value?.replace(/&/g, ampPlaceholder)); //
			}
		}

		for (let i = 0; i < node.childNodes.length; i++) {
			sanitize(node.childNodes[i]);
		}
	}

	sanitize(clonedRoot);

	const htmlString = clonedRoot.innerHTML;

	return htmlString.replace(/&amp;/g, '&').replace(new RegExp(ampPlaceholder, 'g'), '&amp;');
}
